import React from 'react';
import { TabWrapper } from './style';
import { useUI } from '../../contexts/UIContext';
import { useLocation, useNavigate } from 'react-router-dom';

const CustomTab = ({
  tabValue = '',
  tabDataMap = [
    {
      value: '',
      name: '',
      pathName: '',
    },
  ],
}) => {
  const { setContextLoading } = useUI();
  const navigate = useNavigate();
  const location = useLocation();

  const onClickTab = (event, path) => {
    if (tabValue !== event.target.name) {
      setContextLoading(true);
      navigate({
        pathname: path || location.pathname,
        search: `?tab=${event.target.name}`,
      });
    } else return;
  };

  return (
    <TabWrapper className="tabWrapper">
      {tabDataMap.map((item, index) => (
        <button
          key={`tab_button_${index}`}
          name={item.value}
          type="button"
          className={tabValue === item.value ? 'active' : ''}
          onClick={event => onClickTab(event, item?.pathName)}
        >
          {item.name}
        </button>
      ))}
    </TabWrapper>
  );
};

export default CustomTab;
